import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import type {Context} from 'src/common/types'
import TestimonialsSectionDefault from './DefaultVariation'
import {PartnershipsVariant} from './PartnershipsVariant'
import {TestimonialsCarouselVariation} from './TestimonialsCarouselVariation'
import TestimonialsSectionV2 from './V2Variation'
import {TestimonialsVideosVariation} from './VideosVariation'

/**
 * Props for `TestimonialsSection`.
 */
export type TestimonialsSectionProps = SliceComponentProps<Content.TestimonialsSectionSlice> & {context: Context}

/**
 * Component for "TestimonialsSection" Slices.
 */
const TestimonialsSection: FC<TestimonialsSectionProps> = ({slice, index: componentIndex, context}) => {
  switch (slice.variation) {
    case 'default':
      return <TestimonialsSectionDefault slice={slice} index={componentIndex} context={context} />
    case 'v2':
      return <TestimonialsSectionV2 slice={slice} index={componentIndex} context={context} />
    case 'partnerships':
      return <PartnershipsVariant slice={slice} index={componentIndex} pageUid={context.pageUid} />
    case 'testimonialVideos':
      return <TestimonialsVideosVariation slice={slice} componentIndex={componentIndex} pageUid={context.pageUid} />
    case 'carousel':
      return <TestimonialsCarouselVariation slice={slice} />
    default:
      return null
  }
}

export default TestimonialsSection
